import { AppRouter } from '../state/state.router'
import {
    clearHomePageSearchResults,
    search,
    updateSearchQuery,
} from '../state/state.search'
import { routerPush } from '../utilities/router'

export function headerSearch(query = '') {
    const visiblePage = AppRouter.route.visiblePage //router.asPath.toLowerCase()
    const isHomePage = visiblePage === ''
    const trimmedQuery = query.trim()
    // minimum of 2 characters to search
    if (trimmedQuery.length === 1) return
    if (trimmedQuery.length === 0) {
        clearHomePageSearchResults()
        return
    }
    updateSearchQuery({
        search: trimmedQuery?.toLocaleLowerCase(),
        fromHomePage: isHomePage,
        type: null,
    })
    search()
    if (!isHomePage) {
        const path = `/search?query=${trimmedQuery}`
        routerPush(path)
    }
}
